var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1123.000000pt",
    viewBox: "0 0 1280.000000 1123.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1123.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6246 11214 c-171 -38 -318 -126 -413 -248 -17 -23 -150 -248 -296 -501 -450 -784 -1475 -2554 -3497 -6035 -1144 -1971 -1953 -3367 -1973 -3405 -59 -117 -80 -279 -53 -415 34 -167 93 -276 216 -401 90 -91 168 -141 280 -180 l65 -23 4105 4 c2258 1 4881 6 5830 10 1561 6 1730 8 1773 23 202 69 348 201 442 402 57 121 70 179 70 315 0 98 -4 127 -28 196 -20 61 -161 312 -600 1065 -921 1580 -2526 4344 -3900 6714 l-1275 2200 -83 85 c-94 96 -175 144 -299 180 -100 29 -270 35 -364 14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrangle);
export default __webpack_public_path__ + "static/media/trangle.abed06caa06980ad5e9ae9bf9e2b0a62.svg";
export { ForwardRef as ReactComponent };